import { ReactNode } from 'react';

import { Grid, useTheme } from '@simplywallst/ui-core';

import ActionSheet, { Background, Sheet } from '@components/ActionSheet';
import { PreventWindowScroll } from './components/PreventWindowScroll';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  children?: ReactNode;
};

export const NarrativeFairValueActionSheet = ({
  isOpen,
  onClose,
  children,
}: Props) => {
  const theme = useTheme();

  return (
    <ActionSheet open={isOpen} onClose={onClose}>
      <PreventWindowScroll />
      <Background onClick={onClose} />
      <Sheet>
        <Grid
          templateRows={`calc(40px + ${theme.safeAreaInsetTop}) auto`}
          data-cy-id="narrative-fair-value-modal"
        >
          <Grid
            backgroundColor="charcoal"
            templateRows="max-content 1fr"
            row="2"
            borderTopLeftRadius="x2"
            borderTopRightRadius="x2"
          >
            {children}
          </Grid>
        </Grid>
      </Sheet>
    </ActionSheet>
  );
};
